// extracted by mini-css-extract-plugin
export var container = "_ed-1";
export var cornerButtonContainer = "_ed-6";
export var disabled = "_ed-2";
export var dragActive = "_ed-3";
export var fileContainer = "_ed-5";
export var hiddenInput = "_ed-4";
export var widthContainer = "_ed-0";